import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const saveActionCenter = async (data) => {
  try {
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/action-center/log`,
      data,
    );
  } catch (error) {
    console.error(error);
  }
};

export const getDriverDetails = async (job, uuid) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/action-center/driver/${job}`,
      uuid,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getNotifications = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/action-center/notifications`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUnauthorizedStops = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/action-center/unauthorized-stops`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getUnauthorizedStopCounts = async (payload) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/action-center/unauthorized-stops/counts`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
